// export default 'http://localhost:5000';
export default 'https://ngroupart.com';
